import type { Finding, Recommendation } from './rules/types';

const SEVERITY_WEIGHT: Record<string, number> = { fail: 3, warn: 2, info: 1 };

export function buildRecommendations(findings: Finding[], limit = 5): Recommendation[] {
  return findings
    .filter((f) => (f.status === 'fail' || f.status === 'warn') && f.fix)
    .sort((a, b) => {
      const s = SEVERITY_WEIGHT[b.status] - SEVERITY_WEIGHT[a.status];
      if (s !== 0) return s;
      return b.weight - a.weight;
    })
    .slice(0, limit)
    .map((f) => ({
      id: f.id,
      title: f.title,
      why: f.message,
      fix: f.fix ?? '',
      severity: f.status === 'fail' ? 'fail' : 'warn',
    }));
}
